import React from 'react';
import {Container, Card, Row, Col} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/styles/C911Ced.scss';
import { useSelector } from 'react-redux';
import {CabezaCedula,IdentEsc,VersionCifras,PieCedula,ClaveEsc,CicloCenso,TotalAlumnos,Separador,SumaSet,NotaAula,TurnoNombre,ActHojas} from './ToolsCed';

// control de documentos
let tothoja=0;

function DatosCifrasInic(props){
  let hojent=0;
  let hojfracc=0;
  let numhoja=0;
  let reg1hoja=0;
  let poselem=props.indice+1;
  if (poselem<=2){
    numhoja=1;
  }else{
    hojent=Math.trunc((poselem-2)/props.regxanexo);
    hojfracc=(poselem-2) % props.regxanexo;
    if (hojfracc>0){
      hojfracc=1;
    }
    numhoja=1+hojent+hojfracc;
  }
  if (numhoja<=1){
    reg1hoja=1;
  }else{
    reg1hoja=(numhoja-1)*props.regxanexo;
  }
  if (numhoja>tothoja){
    tothoja=numhoja;
  }
  return (
    <div id={props.indice}>
      {Separador (poselem,reg1hoja)}
      {TurnoNombre([props.cifras.turno,props.cifras.turno1,props.cifras.turno2,props.cifras.turno3])}
      <Row><Col xs={12}><h6 className="font-weight-bold">I. ALUMNOS, GRUPOS, DOCENTES Y AULAS</h6></Col></Row>                        
      <Row>
        <Col xs={8}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters text-center margeninf">
                <Col xs={4}><div><p>&nbsp;</p></div></Col>
                <Col xs={2}><div><p>Lactante (L)</p></div></Col>
                <Col xs={2}><div><p>Maternal (M)</p></div></Col>
                <Col xs={2}><div><p>Preescolar (P)</p></div></Col>
                <Col xs={2}><div><p>Total</p></div></Col>            
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={4}><div className="bordetransparente text-left"><p>Alumnos</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.alum0}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.alum1}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.alum2}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.alumtot}</p></div></Col>            
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={4}><div className="bordetransparente text-left"><p>Grupos</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.grupo0}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.grupo1}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.grupo2}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.grupotot}</p></div></Col>            
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={4}><div className="bordetransparente text-left"><p>Docentes frente a grupo</p></div></Col>
                <Col xs={2}><div className="borde"><p>-</p></div></Col>
                <Col xs={2}><div className="borde"><p>-</p></div></Col>
                <Col xs={2}><div className="borde"><p>-</p></div></Col>
                <Col xs={2}><div className="borde"><p>{SumaSet([props.cifras.doc,props.cifras.dircgpo])}</p></div></Col>            
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={2}>
          <Row className="text-center">
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={6}><div><p>Hom</p></div></Col>
                <Col xs={6}><div><p>Muj</p></div></Col>
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={6}><div className="borde"><p>{props.cifras.alumhom}</p></div></Col>
                <Col xs={6}><div className="borde"><p>{props.cifras.alummuj}</p></div></Col>          
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={2}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters text-center margeninf">
                <Col xs={8}><div><p>&nbsp;</p></div></Col>
                <Col xs={4}><div><p>Aulas</p></div></Col>
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={8}><div className="bordetransparente"><p>Existentes</p></div></Col>
                <Col xs={4} className="text-center"><div className="borde"><p>{props.cifras.aulaexis}</p></div></Col>          
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={8}><div className="bordetransparente"><p>En Uso</p></div></Col>
                <Col xs={4} className="text-center"><div className="borde"><p>{props.cifras.aulauso}</p></div></Col>         
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={8}><div className="bordetransparente"><p>Adaptadas</p></div></Col>
                <Col xs={4} className="text-center"><div className="borde"><p>{props.cifras.aulaadap}</p></div></Col>           
              </Row>
              <Row className="margensupaula">
                <Col xs={12} className="text-left">
                  <p className="fontmaspeque">{NotaAula()}</p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="margeninf">
        <Col xs={10}></Col>
        <Col xs={2} className="text-left">
          <p className="fontmaspeque">&nbsp;</p>
        </Col>
      </Row>
      <Row><Col xs={12}><h6 className="font-weight-bold">II. PERSONAL POR FUNCIÓN</h6></Col></Row>
      <Row>
        <Col xs={4}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold"><div><p>Personal de serv. pedagógico</p></div></Col>
                <Col xs={2} className="font-weight-bold"><div className="borde text-center"><p>{props.cifras.pedagogo}</p></div></Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={10}><div className="bordetransparente font-weight-bold"><p>Puericultores</p></div></Col>
                <Col xs={2}><div className="borde text-center font-weight-bold"><p>{props.cifras.puericultor}</p></div></Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={10}><div className="bordetransparente font-weight-bold"><p>Educadores</p></div></Col>
                <Col xs={2}><div className="borde text-center font-weight-bold"><p>{props.cifras.doc}</p></div></Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold"><div><p>Asistentes educativos (L,M y P)</p></div></Col>
                <Col xs={2} className="font-weight-bold"><div className="borde text-center"><p>{props.cifras.asistente}</p></div></Col>
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={10}><div className="bordetransparente font-weight-bold"><p>Personal del equipo técnico</p></div></Col>
                <Col xs={2}><div className="borde text-center font-weight-bold"><p>{props.cifras.tecnico}</p></div></Col>            
              </Row>
                <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold"><div><p>Personal de servs. de nutrición</p></div></Col>
                <Col xs={2} className="font-weight-bold"><div className="borde text-center"><p>{props.cifras.nutricion}</p></div></Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={4}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={10}><div className="bordetransparente font-weight-bold"><p>Personal Directivo</p></div></Col>
                <Col xs={2}><div className="borde text-center font-weight-bold"><p>{SumaSet([props.cifras.dircgpo,props.cifras.dirsgpo])}</p></div></Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={9} className="bordetransparente"><p>Con grupo</p></Col>
                <Col xs={2} className="borde text-center"><p>{props.cifras.dircgpo}</p></Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={9} className="bordetransparente"><p>Sin grupo</p></Col>
                <Col xs={2} className="borde text-center"><p>{props.cifras.dirsgpo}</p></Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold"><div><p>Subdirectores</p></div></Col>
                <Col xs={2} className="font-weight-bold"><div className="borde text-center"><p>{props.cifras.subdir}</p></div></Col>
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={10}><div className="bordetransparente font-weight-bold"><p>Personal admvo. y auxiliar</p></div></Col>
                <Col xs={2}><div className="borde text-center font-weight-bold"><p>{props.cifras.admvo}</p></div></Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={10}><div className="bordetransparente font-weight-bold"><p>Personal de servs. generales</p></div></Col>
                <Col xs={2}><div className="borde text-center font-weight-bold"><p>{props.cifras.general}</p></div></Col>            
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={4}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={10}><div className="bordetransparente font-weight-bold"><p>Personal de otras funciones</p></div></Col>
                <Col xs={2}><div className="borde text-center font-weight-bold"><p>{props.cifras.otro}</p></div></Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold"><div className="bordetransparente"><p>Total de Personal</p></div></Col>
                <Col xs={2} className="font-weight-bold"><div className="borde text-center"><p>{props.cifras.perstot}</p></div></Col>            
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

function LlenaCedula(){
  //const { estad, fechac911 } = useSelector((state) => state.esc);
  const { estad } = useSelector((state) => state.esc);
  let cadena=[];
  let reg=0;
  let regcct=2;
  let regxanexo=3;
  let anexos=0;
  let anexolleno=0;
  let regsinanexo=0;
  let lianexo=0;
  let lsanexo=0;
  let cuerpo;
  const Ciclo=CicloCenso(1);
  reg=estad.length;
  ActHojas(reg,regcct,regxanexo);
  if (reg>0){
    if (reg<=2){
      cuerpo=estad.map((items,index) => <DatosCifrasInic cifras={items} regxanexo={regxanexo} indice={index} />);
      cadena.push(
      <div id='cap1'>
        <CabezaCedula/>
        <IdentEsc/>
        <Card border="dark" style={{ width: 'auto' }}>
          <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
          <Card.Body>
            <TotalAlumnos escuela={estad}/>
            {cuerpo}
          </Card.Body>
        </Card>
        <PieCedula/>
      </div>);
    }else{
      cuerpo=estad.map((items,index) => ((index>=0) && (index<=1))?<DatosCifrasInic cifras={items} regxanexo={regxanexo} indice={index}/>:[]);
      cadena.push(
        <div id='cap2'>
          <CabezaCedula/>
          <IdentEsc/>
          <Card border="dark" style={{ width: 'auto' }}>
            <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
            <Card.Body>
              <TotalAlumnos escuela={estad}/>
              {cuerpo}
            </Card.Body>
          </Card>
          <PieCedula/>
        </div>);  
      anexos=(reg-regcct)/regxanexo;
      anexolleno=Math.trunc(anexos);
      regsinanexo=reg-regcct-(anexolleno*regxanexo);
      lianexo=regcct; /* comienza a partir del registro 2 y omite los registros 0 y 1 */
      lsanexo=regcct+regxanexo-1; /* abarca hasta el 4° registro incluyendo el registro 2 */
      if (anexolleno>0) {
        //anexos llenos
        for (let ii=1; ii <= anexolleno; ii++) {
          cuerpo=estad.map((items,index) => ((index>=lianexo) && (index<=lsanexo))?<DatosCifrasInic cifras={items} regxanexo={regxanexo} indice={index}/>:[])
          cadena.push(
            <div id={ii.toString()}>
              <CabezaCedula/>
              <Card border="dark" style={{ width: 'auto'}}>
                <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
                <Card.Body>
                  <ClaveEsc cvect={estad[0].cvect}/>
                  {cuerpo}
                </Card.Body>
              </Card>
              <PieCedula/>
            </div>);
          lianexo=lianexo+regxanexo;
          lsanexo=lsanexo+regxanexo;
        }
      }else{
        lsanexo=regcct+regsinanexo-1; /* abarca hasta el registro N incluyendo el registro 2 */
      }
      if (regsinanexo>0) {
        //anexos llenos
        cuerpo=estad.map((items,index) => ((index>=lianexo) && (index<=lsanexo))?<DatosCifrasInic cifras={items} regxanexo={regxanexo} indice={index}/>:[]);
        cadena.push(
          <div id="cap4">
            <CabezaCedula/>
            <Card border="dark" style={{ width: 'auto'}}>
              <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
              <Card.Body>
                <ClaveEsc cvect={estad[0].cvect}/>
                {cuerpo}
              </Card.Body>
            </Card>
            <PieCedula/>
          </div>);
      }
    }
  }
  return <Container padding="4rem">{cadena}</Container>;
} //LlenaCedula  

class CedInic extends React.Component {
  render(){
    return (
      <div id="capcedinic">
        <Container padding="4rem">
          <LlenaCedula />
        </Container>
      </div>
    )
  }
}
export default CedInic;